'use strict';

module.exports = {
    api: 'https://itunes.apple.com/search'
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInVybHMuY29uc3RhbnRzLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJhcGkiXSwibWFwcGluZ3MiOiI7O0FBQ0FBLE9BQU9DLE9BQVAsR0FBaUI7QUFDYkMsU0FBSztBQURRLENBQWpCIiwiZmlsZSI6InVybHMuY29uc3RhbnRzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiXG5tb2R1bGUuZXhwb3J0cyA9IHtcbiAgICBhcGk6ICdodHRwczovL2l0dW5lcy5hcHBsZS5jb20vc2VhcmNoJ1xufTsiXX0=